/* store/modules/snackbar */
const snackbar = {
    message: null,
    show: false
}

const state = {
    snackbar: snackbar
}

const mutations = {
    SET_SNACKBAR_MESSAGE(state, data) {
        state.snackbar.message = data
    },

    SET_SNACKBAR_SHOW(state, data) {
        state.snackbar.show = data
    }
}

const actions = {
    setSnackbarMessage: ({ commit }, value) => {
        commit('SET_SNACKBAR_MESSAGE', value)
    },

    setSnackbarShow: ({ commit }, value) => {
        commit('SET_SNACKBAR_SHOW', value)
    }
}

const getters = {
    getSnackbarMessage: state => {
        return state.snackbar.message
    },

    getSnackbarShow: state => {
        return state.snackbar.show
    }
}

export default {
    state,
    mutations,
    actions,
    getters
}